import React from 'react';
import Icon from '../../../components/AppIcon';

const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 })?.format(amount || 0);

const STATUS_STYLES = {
  Draft: 'bg-slate-500/15 text-slate-600',
  Submitted: 'bg-blue-500/15 text-blue-600',
  Accepted: 'bg-emerald-500/15 text-emerald-600',
  Rejected: 'bg-red-500/15 text-red-600',
  'Converted to Project': 'bg-violet-500/15 text-violet-600',
};

const BidCard = ({ bid, onOpenDetail }) => {
  const statusStyle = STATUS_STYLES?.[bid?.status] || 'bg-muted text-muted-foreground';
  const bidNumber = bid?.bidNumber || bid?.bid_number || `B-${bid?.id?.slice(0, 6)}`;
  const customerName = bid?.customerName || bid?.customer_name || 'Unknown Customer';
  const projectName = bid?.projectName || bid?.project_name || 'Unnamed Project';
  const totalAmount = bid?.totalAmount ?? bid?.total_amount ?? 0;
  const createdDate = bid?.createdDate || bid?.created_date;

  return (
    <div
      className="bg-card border border-border rounded-2xl p-4 active:scale-[0.98] transition-transform cursor-pointer"
      onClick={() => onOpenDetail(bid)}
    >
      {/* Top row */}
      <div className="flex items-start justify-between gap-2 mb-2">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-0.5">
            <span className="text-xs font-mono font-semibold text-muted-foreground">{bidNumber}</span>
            <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${statusStyle}`}>
              {bid?.status}
            </span>
          </div>
          <h3 className="text-sm font-semibold text-foreground truncate">{projectName}</h3>
        </div>
        <div className="text-right flex-shrink-0">
          <p className="text-base font-bold text-foreground">{formatCurrency(totalAmount)}</p>
        </div>
      </div>
      {/* Customer + date */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5">
          <Icon name="Building2" size={13} className="text-muted-foreground" />
          <span className="text-xs text-muted-foreground truncate max-w-[160px]">{customerName}</span>
        </div>
        {createdDate && (
          <span className="text-xs text-muted-foreground">
            {new Date(createdDate)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
          </span>
        )}
      </div>
      {/* Convert to project hint for accepted bids */}
      {bid?.status === 'Accepted' && (
        <div className="mt-3 flex items-center gap-1.5 bg-emerald-500/10 rounded-xl px-3 py-2">
          <Icon name="ArrowRight" size={13} className="text-emerald-600" />
          <span className="text-xs font-medium text-emerald-600">Ready to convert to project</span>
        </div>
      )}
    </div>
  );
};

export default BidCard;
